
import CountComponent from '@/components/pages/home/CountComponent.vue';
import {findEntities, findEntity} from '@/repositories/local/CountLocal';
import CountItemPayload from '@/models/payloads/CountItemPayload';

export default class CountEntitiesComponent extends CountComponent {
  protected finder = findEntity;
  protected payload: CountItemPayload[] = findEntities();
  protected color: string = 'green'
}
